import React from "react";
import { connect } from 'react-redux'
import GameDescription from './GameDescription';
import CurrentPrice from './CurrentPrice';

import BetValueModal from "./BetValueModal";
import BetConfirmation, { BetConfirmationState } from './BetConfirmation';
import CircularCounter, { CircularCounterState } from './CircularCounter';
import BetValueMenu from './BetValueMenu';

import GameBet, { BetState } from "./GameBet";
import PoolSize from "./PoolSize";

import LiveRound, { LiveMenuState } from "./LiveRound";
import { Contest, ContestState, getBTCPrice } from '../../utils/ws'
import PlayArea from './PlayArea';
import PlayAreaDesktop from "./PlayAreaDesktop";

import { timer } from "../../utils/utils";
import { desktopSize } from "../../utils/constants";

import { BetType } from "./Enums";
import { PlayAreaState } from "./Enums";

import Confetti from 'react-confetti'


import '../../scss/play.scss'
import App from "../../App";
import { getContestsStore } from "../../redux/contests/selectors";
import { selectAuth } from "../../redux/auth/selectors";
import { Toast } from "../Toast";
import _ from "lodash";

interface PlayState {
    betValue: number,
    betOdd: number,
    showBetValueModal: boolean,
    showBetConfirmationModal: boolean,
    betType: BetType,
    closedContest: any,
    liveContest: any,
    openContest: any,
    bets: GameBet[],
    isMobile: boolean,
    width: number,
    height: number,
    confetti: boolean,
    btcPrice: number,
    showToast: boolean,
    isChecked: boolean
}
interface PlayProps {
    getContestStore: any,
    auth: string
}

class Play extends React.Component<PlayProps, PlayState> {

    playArea = React.createRef<PlayArea>()
    playAreaDesktop = React.createRef<PlayAreaDesktop>()
    circularCounter = React.createRef<CircularCounter>()
    betModal = React.createRef<BetConfirmation>()
    poolSize = React.createRef<PoolSize>()
    betValueMenu = React.createRef<BetValueMenu>()
    liveRound = React.createRef<LiveRound>()
    currentPrice = React.createRef<CurrentPrice>()
    rootContainer = React.createRef<HTMLDivElement>()

    gameTimer = 0;
    dataTimer? : any;
    loading = false;

    constructor(props:PlayProps) {
        super(props)

        this.state = {
            betValue: 5,
            betOdd: 0,
            showBetValueModal: false,
            showBetConfirmationModal: false,
            betType: BetType.closeAbove,
            closedContest: new Contest(new Date(), ContestState.close, 0),
            liveContest: new Contest(new Date(), ContestState.live, 0),
            openContest: new Contest(new Date(), ContestState.open, 0),
            bets: [],
            isMobile: false,
            width: window.innerWidth,
            height: window.innerHeight,
            confetti: false,
            btcPrice: 0,
            showToast: false,
            isChecked: false
        }
    }


    public componentDidMount = ():void => {

        this.dataTimer = setInterval(() => {
            if (!this.loading)
                this.getContests();
        }, 1000)

        window.addEventListener('resize', this.onResizeHandler)
        setTimeout(() => {
            this.onResizeHandler();
        }, 100);
        this.getContests();
    }

    componentWillUnmount(): void {
        
        clearInterval(this.dataTimer);
        window.removeEventListener('resize', this.onResizeHandler)
    }

    private onResizeHandler = (): void => {

        this.setState({
            isMobile: this.rootContainer.current.clientWidth < desktopSize ? true : false,
            width: this.rootContainer.current.offsetWidth,
            height: this.rootContainer.current.offsetHeight
        });

    }

    private getContests = async () => {

        this.loading = true;

        const btcPrice = await getBTCPrice();
        this.setState({
            btcPrice: btcPrice
        })
        
        if (!this.props.getContestStore.length) {
            this.loading = false;
            return
        }
        
        const liveContestIdx = this.props.getContestStore.findIndex(({ status }:{ status:string}) => ['Live', 'GoingLive'].includes(status));
        if (liveContestIdx > -1) {
            let live: any;
            let open: any;
            let close: any;
            if ((60 - Math.round((new Date().getTime() - new Date(this.props.getContestStore[liveContestIdx].contestLiveTime).getTime()) / 1000)) > 0) {
                live = this.props.getContestStore[liveContestIdx];
                open = this.props.getContestStore[liveContestIdx + 1];
                close = this.props.getContestStore[liveContestIdx -1] || {};
            } else {
                live = this.props.getContestStore[liveContestIdx + 1];
                open = this.props.getContestStore[liveContestIdx + 2];
                close = this.props.getContestStore[liveContestIdx] || {};
            }

            if (this.state.openContest.id === live.id) {
                this.changeGame(close, live);
            }
            
            this.setState({
                openContest: open,
                liveContest: live,
                closedContest: close
            })
            if (!this.state.isChecked) {
                const betsLocalStorage = JSON.parse(localStorage.getItem('bets_contests'))
                if(betsLocalStorage?.length) {
                    this.setState({
                        bets: betsLocalStorage,
                    })
                    for(let i = 0 ; i < betsLocalStorage.length;i++){
                        if (betsLocalStorage[i].id === open.id) {
                            this.setState({
                                betType: betsLocalStorage[i].betType,
                                betOdd: betsLocalStorage[i].betType === BetType.closeAbove ? this.state.openContest!.moonOdds || 0 : this.state.openContest!.rektOdds || 0,
                                showBetConfirmationModal: true,
                            })
                            this.betValueMenu?.current?.hide();
                            this.poolSize?.current?.hide();
                            this.playAreaDesktop?.current?.shoHideButtons(false);
                            this.liveRound?.current?.setLiveRoundState(LiveMenuState.close);
                            this.betModal?.current?.setState({betState:BetConfirmationState.confirmed})
                            this.betModal?.current?.showNextRoundTitle(true)
                            if (this.state.isMobile) {
                                this.circularCounter?.current?.setCircularCounterState(CircularCounterState.low);
                                this.playArea?.current?.setPlayAreaState(PlayAreaState.open);
                                this.playArea?.current?.lowerBackground(LiveMenuState.close);
                                this.betModal?.current?.lowerContent(LiveMenuState.close);
                                this.playArea?.current?.openButton(betsLocalStorage[i].betType);
                                this.makeBetHandler(betsLocalStorage[i].betType)
                            }
                            else {
                                this.betModal?.current?.flipCard();
                            }
                        }
                    }
                }
            }
        }
        this.loading = false;
        this.setState({
            isChecked: true
        })
    }

    private changeGame = async (close: any, live: any) => {

        let showResults: boolean = false;
        const bets = [...this.state.bets];
        for (let i = 0; i < bets.length; i++) {
            if (bets[i].id === close.id) {
                showResults = true;
                this.showResult(bets[i], close);
                bets.splice(i, 1);
            }
        }

        for (let i = 0; i < bets.length; i++) {
            if (bets[i].id === live.id)
                bets[i].state = BetState.live;
        }

        if (this.betModal && this.betModal.current)
            this.betModal.current.fullyClose();

        this.poolSize.current?.show();
        if (this.state.isMobile) {

        }
        this.playArea.current?.setPlayAreaState(PlayAreaState.close);
        this.liveRound.current?.openDetails(LiveMenuState.close);
        await timer(showResults ? 3000 : 0);
        this.liveRound.current?.hideResult();
        await timer(showResults ? 1000 : 0);
        this.setState({ bets: bets });
    }

    private showResult = (gameBet: GameBet, contest: any): void => {
        if (contest.instrumentPrices[0].closePrice.blendedPrice > contest.instrumentPrices[0].livePrice.blendedPrice) {
            if (gameBet.betType === BetType.closeAbove)
                this.showResultLabel(true);
            else
                this.showResultLabel(false);
        } else {
            if (gameBet.betType === BetType.closeAbove)
                this.showResultLabel(false);
            else
                this.showResultLabel(true);
        }
    }

    private showResultLabel = (value: boolean) => {
        this.liveRound.current?.showResult(value);
        if (value) {
            this.setState({ confetti: true });
            setTimeout(() => {
                this.setState({ confetti: false });
            }, 2500);

        }
    }

    private showBetValueModalHandler = (show: boolean): void => {

        this.setState({ showBetValueModal: show })
    }


    onDetailsPanelHandler = (liveMenuState: LiveMenuState): void => {

        if (this.state.showBetConfirmationModal && this.state.isMobile) {
            this.playArea.current?.lowerBackground(liveMenuState);
            this.betModal.current?.lowerContent(liveMenuState);
            this.circularCounter.current?.lowerContent(liveMenuState);
        }

        if (this.state.isMobile)
            this.currentPrice.current?.hide(liveMenuState);
    }

    setBetValue = (value: number) => {

        this.setState({ betValue: value })
    }

    makeBetHandler = (betType: BetType) => {

        this.liveRound.current?.setLiveRoundState(LiveMenuState.close);
        this.betValueMenu.current?.hide();
        this.poolSize.current?.hide();
        this.setState({
            showBetConfirmationModal: true,
            betType: betType,
            betOdd: betType === BetType.closeAbove ? this.state.openContest!.moonOdds || 0 : this.state.openContest!.rektOdds || 0
        });
    }

    onBetConfirmationCloseComplete = () => {

        if (!this.state.isMobile) {
            this.playAreaDesktop.current.shoHideButtons(true);
        }
        this.betValueMenu.current?.show();
        this.circularCounter.current?.setCircularCounterState(CircularCounterState.normal);
        this.setState({ showBetConfirmationModal: false, betType: BetType.closeBellow });
    }

    onBetConfirmationHandler = (confirm: boolean, toast: boolean, contestEntry: any) => {

        if (!confirm) {
            this.betValueMenu.current?.show();
            this.betModal.current.fullyClose();
            this.playArea.current?.closeButton();
            this.poolSize.current.show();
            this.handleShowToast(toast)
        }
        else {

            const bet = new GameBet(contestEntry.contestId
                , contestEntry.wager
                , contestEntry.direction === "Moon" ? BetType.closeAbove : BetType.closeBellow
                , BetState.open
                , this.state.betType === BetType.closeAbove ? this.state.openContest?.moonOdds || 0 : this.state.openContest?.rektOdds || 0
                , this.state.openContest.contestLiveTime);


            const bets = this.state.bets as GameBet[];
            bets.push(bet);
            this.setState({ bets: bets});
            localStorage.setItem('bets_contests', JSON.stringify(bets))
            this.handleShowToast(toast)

            if (this.state.isMobile) {
                this.circularCounter.current?.setCircularCounterState(CircularCounterState.low);
                this.playArea.current?.lowerBackground(LiveMenuState.close);
                this.betModal.current?.lowerContent(LiveMenuState.close);
            }
            else {
                this.betModal.current?.flipCard();
            }
        }
    }

    handleShowToast = (value:boolean) => {
        this.setState({
            showToast: value
        })
    }

    render() {
        if (this.props.getContestStore.length) {
            if (this.state.isMobile)
                return this.getMobile();
            else
                return this.getDesktop();
        }
       return (
        <div ref={this.rootContainer} className="loading"></div>
       )
    }

    getDesktop = () => {
        return (
            <div ref={this.rootContainer} className="play-desktop">
                {this.getConfetti()}
                <div className="header-container">
                    <GameDescription 
                        isMobile={this.state.isMobile}
                    />
                    {this.getLiveRount()}
                </div>
                <div></div>
                <CurrentPrice
                    ref={this.currentPrice}
                    btcPrice={this.state.btcPrice}
                    nextContestTime={Math.round((new Date().getTime() - new Date(this.state.liveContest.contestLiveTime).getTime()) / 1000)}
                    totalTime={60}
                    isMobile={this.state.isMobile}
                />
                <PlayAreaDesktop
                    ref={this.playAreaDesktop}
                    openContest={this.state.openContest}
                    makeBetHandler={this.makeBetHandler}
                    betValue={this.state.betValue} />
                <PoolSize
                    ref={this.poolSize}
                    poolValue={this.state.openContest?.prizePool || 0}
                    isMobile={this.state.isMobile}
                    />
                {this.getBetModal()}
                {this.getConfirmationModal()}
                {this.getToast()}
                <BetValueMenu
                    ref={this.betValueMenu}
                    betValue={this.state.betValue}
                    showBetValueModalHandler={this.showBetValueModalHandler} 
                    isMobile={this.state.isMobile}
                    />
                <CircularCounter
                    ref={this.circularCounter}
                    currentValue={60 - Math.round((new Date().getTime() - new Date(this.state.liveContest.contestLiveTime).getTime()) / 1000)}
                    total={60}
                    isMobile={this.state.isMobile}
                />
            </div>
        )

    }

    getMobile = () => {

        return (
            <div ref={this.rootContainer} className="play-mobile">
                {this.getConfetti()}
                {this.getBetModal()}
                {this.getHeader()}
                {this.getConfirmationModal()}
                {this.getToast()}
                <BetValueMenu
                    ref={this.betValueMenu}
                    betValue={this.state.betValue}
                    showBetValueModalHandler={this.showBetValueModalHandler} 
                    isMobile={this.state.isMobile}
                    />
                <CircularCounter
                    ref={this.circularCounter}
                    currentValue={60 - Math.round((new Date().getTime() - new Date(this.state.liveContest.contestLiveTime).getTime()) / 1000)}
                    total={60}
                    isMobile={this.state.isMobile}
                />
                <CurrentPrice
                    ref={this.currentPrice}
                    btcPrice={this.state.btcPrice}
                    nextContestTime={Math.round((new Date().getTime() - new Date(this.state.liveContest.contestLiveTime).getTime()) / 1000)}
                    totalTime={60}
                    isMobile={this.state.isMobile}
                />
                <PlayArea
                    ref={this.playArea}
                    openContest={this.state.openContest}
                    makeBetHandler={this.makeBetHandler}
                    betValue={this.state.betValue} />
                <PoolSize
                    ref={this.poolSize}
                    poolValue={this.state.openContest?.prizePool || 0}
                    isMobile={this.state.isMobile}
                    />
            </div>
        )

    }

    getConfetti = () => {
        const color1 = App.getPropertyFromStyle('--win-color')
        const color2 = App.getPropertyFromStyle('--lose-color')
        return(
        <div className="confetti-container">
            <Confetti
                width={this.state.width}
                height={this.state.height}
                gravity={0.2}
                colors={[color1, color2, '#FFFFFF']}
                numberOfPieces={this.state.confetti ? 500 : 0}
            />
        </div>
        )
    }

    getHeader = () => {
        if (!this.state.liveContest?.instrumentPrices?.length && !this.state.liveContest?.instrumentPrices?.[0].livePrice.blendedPrice)
            return <GameDescription isMobile={this.state.isMobile}/>
        else
            return this.getLiveRount();

    }

    getLiveRount = () => {

        if (!this.state.liveContest?.instrumentPrices?.length && !this.state.liveContest?.instrumentPrices?.[0].livePrice.blendedPrice)
            return;

        return <LiveRound
            ref={this.liveRound}
            isMobile={this.state.isMobile}
            liveContest={this.state.liveContest}
            openContest={this.state.openContest}
            bets={this.state.bets!}
            onDetailsPanelHandler={this.onDetailsPanelHandler}
            btcPrice={this.state.btcPrice}
        />
    }

    getConfirmationModal = () => {
        if (this.state.showBetConfirmationModal) {
            return <BetConfirmation
                ref={this.betModal}
                isMobile={this.state.isMobile}
                betOdd={this.state.betOdd}
                stack={this.state.betValue}
                openContest={this.state.openContest!}
                onBetConfirmationCloseComplete={this.onBetConfirmationCloseComplete}
                onBetConfirmationHandler={this.onBetConfirmationHandler}
                betType={this.state.betType}
                btcPrice={this.state.btcPrice}
                auth={this.props.auth}
            />
        }
    }

    getBetModal = () => {
        if (this.state.showBetValueModal)
            return <BetValueModal
                isMobile={this.state.isMobile}
                setBetValue={this.setBetValue}
                showBetValueModalHandler={this.showBetValueModalHandler}
                betValue={this.state.betValue} />;
    }

    getToast = () => {
        if (this.state.showToast)
            return <Toast
                status="error"
                message="Insufficient Funds"
                onClose={()=>this.handleShowToast(false)}
            />
    }
}
const mapStateToProps = (state:any) => ({
  getContestStore: getContestsStore(state),
  auth: selectAuth(state)
})

const mapDispatchToProps = (dispatch:any) => ({
    
})
export default connect(mapStateToProps,mapDispatchToProps)(Play)